import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { AlertaMaquina } from 'src/app/mapa/models/AlertaMaquina';
import { IFiltroAlertaMaquina } from 'src/app/mapa/models/IFiltroAlertaMaquina';
import { IFiltroEstadisticaMaquina } from 'src/app/mapa/models/IFiltroEstadisticaMaquina';
import { IMaquinaInforme } from 'src/app/mapa/models/IMaquinaInforme';
import { IReporteInforme } from 'src/app/mapa/models/IReporteInforme';
import { ICalendarioMaquina } from 'src/app/usuarios/models/IMaquinaFecha';
import { IMaquinaUsuario } from 'src/app/usuarios/models/IMaquinaUsuario';
import { ICombo } from 'src/app/usuarios/models/combo.model';
import { BaseService } from '../../core/services/base.service';
import { IMaquinaEstadoActual } from '../models/IMaquinaEstadoActual';
import { IMaquina, IMaquinaEstadoResponse } from '../models/maquina';

@Injectable({
	providedIn: 'root',
})
export class MaquinaService {
	constructor(protected http: HttpClient, private service: BaseService) { }

	getByUsuario(IdEmpresa: number, IdUsuario: number): Observable<IMaquinaEstadoResponse> {
		return this.service
			.doGet('api/Maquinas/GetActivasByUsuario?idEmpresa=' + IdEmpresa + '&idUsuario=' + IdUsuario)
			.pipe<IMaquinaEstadoResponse>(
				tap((response: any) => {
					return response;
				})
			);
	}
	getCalendarioByEmpresa(idEmpresa: number, fechaDesde:any): Observable<ICalendarioMaquina[]> {
		return this.service.doGet('api/Maquinas/GetCalendarioMaquinas?idEmpresa=' + idEmpresa + "&fechaDesde=" + fechaDesde).pipe<ICalendarioMaquina[]>(
			tap((response: any) => {
				return response;
			})
		);
	}
//metodo con filtro de fecha integrar a futuro
// 	getCalendarioByEmpresa(idEmpresa: number, fechaDesde: any): Observable<ICalendarioMaquina[]> {
//     console.log(idEmpresa, "idempresa servicio", fechaDesde, "fecha en servicio");
//     return this.service
//         .doGet('api/Maquinas/GetCalendarioMaquinas?idEmpresa=' + idEmpresa + '&fechaDesde=' + fechaDesde)
//         .pipe<ICalendarioMaquina[]>(
//             map((response: ICalendarioMaquina[]) => {
//                 console.log("Respuesta completa del calendario:", response);

//                 // const now = new Date();
//                 // console.log("Fecha actual:", now.toISOString());

//                 // const filteredResponse = response.filter(calendarData => {
//                 //     const fechaDesdeItem = new Date(calendarData.desde);
//                 //     console.log("Comparando:", fechaDesdeItem.toISOString(), "<=", now.toISOString(), "?", fechaDesdeItem.getTime() <= now.getTime());

//                 //     return fechaDesdeItem.getTime() <= now.getTime();
//                 // });

//                 // console.log("Calendario filtrado:", filteredResponse);
//                 return response;
//             }),
//         );
// }



	getAllByUsuario(idEmpresa: number, IdUsuario: number): Observable<IMaquina[]> {
		return this.service
			.doGet('api/Maquinas/getAllByUsuario?idEmpresa=' + idEmpresa + '&idusuario=' + IdUsuario) //todo
			.pipe<IMaquina[]>(
				tap((response: any) => {
					return response;
				})
			);
	}

	getEstadoActualMaquina(IdMaquina: number) {
		return this.service.doGet('api/Maquinas/getEstadoActualById?IdMaquina=' + IdMaquina).pipe<IMaquinaEstadoActual>(
			tap((response: any) => {
				return response;
			})
		);
	}

	getEstadoActualByEmpresaYUsuario(IdEmpresa: number, IdUsuario: number): Observable<IMaquinaEstadoActual[]> {
		return this.service
			.doGet('api/Maquinas/getEstadoActualByEmpresaYUsuario?idempresa=' + IdEmpresa + '&idUsuario=' + IdUsuario)
			.pipe<IMaquinaEstadoActual[]>(
				tap((response: any) => {
					return response;
				})
			);
	}

	getFiltrosReporte(IdMaquina: number): Observable<ICombo[]> {
		return this.service.doGet('api/Maquinas/getFiltrosReporte?idMaquina=' + IdMaquina).pipe<ICombo[]>(
			tap((response: any) => {
				return response;
			})
		);
	}

	updateMaquina(body: IMaquinaUsuario) {
		return this.service.doPut('api/Maquinas/updateMaquinaUsuario', body);
	}

	getReporte(body: IFiltroEstadisticaMaquina): Observable<IMaquinaInforme> {
		return this.service.doPost('api/Maquinas/getMapaById', body).pipe(
			map<Response, IMaquinaInforme>((response: any) => {

				return response;
	
			})
		);
	}

	getReporteChartsData(body: IFiltroEstadisticaMaquina): Observable<IReporteInforme> {
		return this.service.doPost('api/Maquinas/getReporteById', body).pipe(
			map<Response, IReporteInforme>((response: any) => {
				return response;
			})
		);
	}

	getAlertasByMaquina(body: IFiltroAlertaMaquina): Observable<AlertaMaquina[]> {
		return this.service.doPost<AlertaMaquina[]>('api/Maquinas/getEventosMaquina', body).pipe(
			map((response: AlertaMaquina[]) => {
				return response;
			})
		);
	}
}
